<template>
    <v-btn
      :width="width"
      min-width="120"
      rounded
      :height="height"
      class="active-color"
      dark
      @click="onPress"
      :disabled="disabled"
    >
      <span class="bold text-uppercase px-5" style="color: #fff;">{{ label }}</span>
    </v-btn>
  </template>
  
  <script>
  export default {
    props: {
      label: {
        type: String,
        default: ""
      },
      width: {
        type: String,
        default: ""
      },
      height: {
        type: String,
        default: "30px"
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onPress() {
        this.$emit("onPress");
      }
    }
  };
  </script>
  
  <style lang="scss">
  .active-color {
    background-color: $tcdcGreen !important;
  }
  </style>
  